export default __webpack_public_path__ + "static/media/battle-leaderboard.8358b18a.svg";